export default __webpack_public_path__ + "static/media/bottomSort.a9241587.svg";